import { gql } from '@grandvisionhq/graphql';

var GET_PRESCRIPTION_DOWNLOADS = gql`
  query getPrescriptionDownloads {
    me {
      id
      prescriptions {
        ... on PrescriptionDownload {
          id
          expiryDate
          issueDate
          downloadUrl
          fullName
          isValid
          prescriptionType
        }
      }
    }
  }
`;

export { GET_PRESCRIPTION_DOWNLOADS as default };
//# sourceMappingURL=get-prescription-downloads.js.map
